

export class Employee_Dashboard_Monthly_Late_Early implements IEmployee_Dashboard_Monthly_Late_Early {
    entryDate!: Date | undefined;
    earlyTime!: string | undefined;
    lateTime!: string | undefined;

    constructor(data?: IEmployee_Dashboard_Monthly_Late_Early) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.earlyTime = _data["earlyTime"];
            this.lateTime = _data["lateTime"];
        }
    }

    static fromJS(data: any): Employee_Dashboard_Monthly_Late_Early {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_Monthly_Late_Early();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["earlyTime"] = this.earlyTime;
        data["lateTime"] = this.lateTime;
        return data; 
    }
}

export interface IEmployee_Dashboard_Monthly_Late_Early {
    entryDate: Date | undefined;
    earlyTime: string | undefined;
    lateTime: string | undefined;
}

